<div style="height: 70vh; overflow-y: auto">
    <app-shopping-cart
        #cart
        [paymentRequestItem]="paymentItem"
        (paymentSuccess)="approve()"
        [pageType]="'requestOrderPayment'"
    ></app-shopping-cart>
</div>
